import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRulesModel from '@app/models/rules';
import { Settings } from '../settings.state';


export interface RulesAvailable { 
    events: Array<fromRulesModel.AvailableRuleEventElement>;
    conditions: Array<fromRulesModel.AvailableRuleEventCondition>;
    actions: Array<fromRulesModel.AvailableRuleEventAction>;
}

export interface RuleEdit {
    current: fromRulesModel.RuleEvent;
    forms: Array<fromRulesModel.AvailableRuleItemFormModel>;
    event: fromRulesModel.AvailableCurrentEventConfig;
}

export interface SettingsRules {
    availables: RulesAvailable;
    rules: Array<fromRulesModel.RuleListItem>;
    edit: RuleEdit;
}

/**
 *  new structure
{
    availables: {
        events: [{
            key: string
            description: string,
            conditions: [{key: string, description: string}]
            actions: [{key: string, description: string}]
        }],
        conditions: [{key: string, //description: string//, options: array, values: array}],
        actions: [{key: string, type: string, default: string, values: array {key: string, options: any, description: string}}]
    }, 
    edit: {
        current: Rule,
        forms: [
            {
                id: string,
                key: string (available.key),
                type: string (condition/action),
                scroll: {},
                search: {
                    term: string,
                    found: [available]
                }
            }
        ]
    }
}
 */

// export const initialState: SettingsRules = { // old
//     availables: [],
//     rules: [],
//     editing: {
//         id: 0,
//         name: "",
//         key: "",
//         conditions_control: "OR",
//         conditions: [],
//         actions: []
//     },
//     editing_scroll: []
// };

export const initialState: SettingsRules = {
    availables: null,
    rules: [],
    edit: {
        current : {
                    id: 0,
                    name: "",
                    key: "",
                    conditions_control: "OR",
                    conditions: [],
                    actions: []
                },
        forms: [],
        event: null    
    }
};

const settingsFeatureSelector = createFeatureSelector('settings');

const settingsRulesFeatureSelector = createSelector(
    settingsFeatureSelector,
    (state: Settings) => state.rules
);

// Selectors
export const settingsRulesAvailableSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.availables
);

export const settingsRulesAvailableEventsSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.availables?.events
);

export const settingsRulesAvailableEventsConditionsSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.availables?.conditions
);

export const settingsRulesAvailableEventsActionsSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.availables?.actions
);

export const settingsRulesEditFormsConditionsSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) =>  state.edit.forms.filter((f:fromRulesModel.AvailableRuleItemFormModel) => f.type == fromRulesModel.AvailableRuleItemFormTypes.condition )
);

export const settingsRulesEditFormsActionsSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) =>  state.edit.forms.filter((f:fromRulesModel.AvailableRuleItemFormModel) => f.type == fromRulesModel.AvailableRuleItemFormTypes.action )
);

export const settingsRulesRulesSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.rules
);

export const settingsRulesEditCurrentSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.edit.current
);

export const settingsRulesEditEventSelector = createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) => state.edit.event
);

// TODO: need to provide the form id to get the scroll of rthe form
export const settingsRulesEditingScrollSelector =  (id: string) => createSelector(
    settingsRulesFeatureSelector,
    (state: SettingsRules) =>  state.edit.forms.filter((f:fromRulesModel.AvailableRuleItemForm) => f.id == id)[0].scroll 
    //state.editing_scroll
);


